<template>
    <div class="user">
<!--        <el-card>-->
<!--            <el-breadcrumb separator="/">-->
<!--                <el-breadcrumb-item :to="{ name: 'workspace' }">首页</el-breadcrumb-item>-->
<!--                <el-breadcrumb-item>用户管理</el-breadcrumb-item>-->
<!--                <el-breadcrumb-item>用户管理</el-breadcrumb-item>-->
<!--            </el-breadcrumb>-->
<!--        </el-card>-->
        <main class="content">
            <el-card>
                <el-form :inline="true" :model="searchForm" size="mini">
                    <el-form-item label="姓名">
                        <el-input v-model="searchForm.name" placeholder="姓名" size="mini" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="邮箱">
                        <el-input v-model="searchForm.email" placeholder="用户邮箱" size="mini" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="手机号">
                        <el-input v-model="searchForm.mobile" placeholder="用户手机号" size="mini" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="状态">
                        <el-select v-model="searchForm.status" placeholder="账号状态" size="mini" clearable>
                            <el-option label="全部" value=""></el-option>
                            <el-option label="无效" value="0"></el-option>
                            <el-option label="有效" value="1"></el-option>
                            <el-option label="待激活" value="2"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary"
                            @click="() => {
                            this.currentPage=1;
                            onSearch();}"
                            size="mini">查询</el-button>
                    </el-form-item>
                </el-form>
                <div ref="tablePosition"></div>
                <el-table
                    stripe
                    size="mini"
                    :data="tableData"
                    :height="tableConfig.height"
                    v-loading="loading"
                    style="width: 100%">
                    <el-table-column
                        prop="email"
                        label="邮箱">
                    </el-table-column>
                    <el-table-column
                        prop="name"
                        label="姓名"
                        width="300">
                    </el-table-column>
                    <el-table-column
                        prop="mobile"
                        label="手机号"
                        width="180">
                    </el-table-column>
                    <el-table-column
                            prop="status"
                            label="状态"
                            width="100">
                        <template slot-scope="scope">
                            <el-tag
                                    :type="scope.row.status ===  1 ? 'success' : (scope.row.status ===  0 ? 'info' : 'warning')"
                                    disable-transitions>{{scope.row.status === 1 ? '有效' : (scope.row.status ===  0 ? "无效" : "待激活") }}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="admin"
                            label="管理员"
                            width="100">
                        <template slot-scope="scope">
                            <el-tag
                                    :type="scope.row.admin ===  1 ? 'success' : ('info')"
                                    disable-transitions>{{scope.row.admin === 1 ? '是' : ("否") }}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="350" align="right">
                        <template slot="header">
                            <a href="/template/upload_user.xlsx" style="margin-right:16px">下载模板</a>
                            <el-button type="primary" @click="() => uploadDialogVisible = true" size="mini">批量上传</el-button>
                            <el-button type="primary" @click="handleCreateUser" size="mini">添加</el-button>
                        </template>
                        <template slot-scope="scope">
                            <el-button type="text"
                                size="mini"
                                @click="handleEdit(scope.$index, scope.row)">编辑信息</el-button>
                            <el-divider direction="vertical" ></el-divider>
                            <el-button
                                size="mini" type="text"
                                @click="handleResetPassword(scope.$index, scope.row)">重置密码</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div style="text-align: center;padding-top: 20px">
                    <el-pagination
                        background
                        layout="sizes,prev, pager, next"
                        :page-sizes="[10, 20, 50, 100]"
                        v-if="total>0"
                        :total="total"
                        :page-size="pageSize"
                        :current-page="currentPage"
                        @size-change="handleSizeChange"
                        @current-change="onPageChange"
                        @prev-click="onPageChange"
                        @next-click="onPageChange">
                    </el-pagination>
                </div>
            </el-card>
        </main>
        <el-dialog title="用户信息" :visible.sync="editDialogVisible" :before-close="handleClose" width="500px">
            <el-form :model="editForm" label-width="80px" :rules="rules" ref="userInfoForm">
                <el-form-item label="邮箱" prop="email">
                    <el-input v-model="editForm.email"  :disabled="isEdit"   placeholder="请输入邮箱" clearable></el-input>
                </el-form-item>
                <el-form-item label="密码" v-if="editForm.id === ''" prop="password">
                    <el-input v-model="editForm.password" show-password placeholder="请输入密码" clearable></el-input>
                </el-form-item>
                <el-form-item label="姓名">
                    <el-input v-model="editForm.name"  :disabled="isEdit"   placeholder="请输入姓名" clearable></el-input>
                </el-form-item>
                <el-form-item label="手机">
                    <el-input v-model="editForm.mobile"  :disabled="isEdit"   placeholder="请输入手机" clearable></el-input>
                </el-form-item>
                <el-form-item label="状态">
                    <el-select v-model="editForm.status" placeholder="请选择账号状态" clearable>
                        <el-option label="无效" value="0"></el-option>
                        <el-option label="有效" value="1"></el-option>
                        <el-option label="待激活" value="2"></el-option>
                        <el-option label="锁定" value="3"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="管理员">
                    <el-select v-model="editForm.admin" placeholder="请选择是否是管理员" clearable>
                        <el-option label="否" value="0"></el-option>
                        <el-option label="是" value="1"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="editDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="onSubmit">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="重置密码" :visible.sync="mdyPasswordDialogVisible" width="500px">
            <el-form class="user-account-key" ref="editForm" :model="editForm" :rules="rules" label-width="100px">
                <el-form-item label="新密码" prop="password">
                    <el-input type="password" placeholder="请设置新密码" v-model="editForm.password" clearable></el-input>
                </el-form-item>
                <el-form-item label="确认密码" prop="rPassword">
                    <el-input type="password" placeholder="请确认新密码" v-model="editForm.rPassword" clearable></el-input>
                </el-form-item>
            </el-form>
            <el-button @click="$refs['editForm'].resetFields()">重置</el-button>
            <el-button type="primary" @click="onSubmitPwd('editForm')">保存</el-button>
        </el-dialog>
        <el-dialog title="上传用户列表" :modal="true" :visible.sync="uploadDialogVisible" width="400px">
            <el-upload ref="upload"
                class="upload-demo"
                drag
                action="/api/admin/user/upload"
                :limit="1"
                accept=".xlsx"
                :on-success="uploadSuccess">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            </el-upload>
            <div v-html="uploadCheckResult"></div>
        </el-dialog>
    </div>
</template>
<script>
const HEIGHT_OFFSET = 118;
export default {

    data() {
        //此处即表单发送之前验证
        let validateNewPassword2 = (rule, value, callback) => {
            if (value !== "" && value !== this.editForm.password) {
                callback(new Error('两次密码不一致!'))
            } else {
                callback()
            }
        }
        return {
            tableConfig: {
                height: 0,
            },
            searchForm: {
                name: "",
                email: "",
                mobile: "",
                password: "",
                // type: "",
                // vip: "",
                companyTaxCode: "",
                businessLicense: "",
                status: "",
            },
            loading: false,
            total: 0,
            pageSize: 10,
            currentPage: 1,
            tableData: [],
            editDialogVisible: false,
            editForm: {
                id: "",
                name: "",
                email: "",
                mobile: "",
                password: "",
                rPassword: "",
                type: "1",
                vip: "1",
                status: "1",
            },
            isEdit: true,
            mdyPasswordDialogVisible: false,
            editRoleVisible: false,
            userId: "",
            uploadDialogVisible: false,
            uploadCheckResult: "",
            rules: {
                email: [
                    { required: true, message: '请输入邮件地址', trigger: 'blur' },
                    {
                        pattern: /^\s*((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\s*$/i,// eslint-disable-line
                        message: '请输入正确的邮箱地址',
                    }

                ],
                password: [
                    { required: true, message: '请设置新密码', trigger: 'blur' }
                ],
                rPassword: [
                    { required: true, message: '请确认新密码', trigger: 'blur' },
                    { validator: validateNewPassword2, trigger: 'blur' }
                ]
            }
        }
    },
    methods: {
        onSearch() {
            let user = {
            };
            if(this.searchForm.name != "") {
                user["name"] = this.searchForm.name;
            }
            if(this.searchForm.status != "") {
                user["status"] = this.searchForm.status;
            }
            if(this.searchForm.mobile != "") {
                user["mobile"] = this.searchForm.mobile;
            }
            if(this.searchForm.email != "") {
                user["email"] = this.searchForm.email;
            }
            if(this.searchForm.type != "") {
                user["type"] = this.searchForm.type;
            }
            if(this.searchForm.vip != "") {
                user["vip"] = this.searchForm.vip;
            }

            this.loading = true;
            let _this = this
            this.$axios.post("/admin/user/search",{
                cond: user,
                page: this.currentPage - 1,size:this.pageSize
            }).then(function(response) {
                let resp = response.data;
                if(resp.header.status == 0) {
                    _this.loading = false;
                    _this.tableData = resp.data.content;
                    _this.total = resp.data.totalElements;
                }
            }).catch(function() {
            });
        },
        handleCreateUser() {
            this.isEdit = false;
            this.editForm.id = "";
            this.editForm.name = "";
            this.editForm.email = "";
            this.editForm.mobile = "";
            this.editForm.password = "";
            // this.editForm.vip = "0";
            // this.editForm.type = "0";
            this.editForm.status = "0";
            this.editDialogVisible = true;
        },
        onSubmit() {
            let _this = this;
            this.$refs.userInfoForm.validate(valid => {
                if (valid) {
                    this.$axios.post("/admin/user/save", this.editForm)
                    .then(function(response){
                        let resp = response.data;
                        if(resp.header.status == 0) {
                            _this.$notify({
                                title: '成功',
                                message: '数据保存成功',
                                type: 'success'
                            });
                            _this.editDialogVisible = false;
                            _this.onSearch();
                        } else {
                            _this.$notify.error({
                                title: '错误',
                                message: resp.header.msg
                            });
                        }
                    });
                }
            });
        },
        handleSizeChange(pageSize){
            this.pageSize = pageSize;
            this.onSearch();
        },
        onPageChange(currentPage) {
            this.currentPage = currentPage;
            this.onSearch();
        },
        handleEdit(_index, row) {
            this.isEdit = true;
            this.editForm.id = row.id;
            this.editForm.name = row.name;
            this.editForm.email = row.email;
            this.editForm.mobile = row.mobile;
            // this.editForm.vip = row.vip+ "";
            // this.editForm.type = row.type+ "";
            this.editForm.status = row.status + "";
            this.editDialogVisible = true;
        },
        handleResetPassword(index, row) {
            this.editForm.name = row.name;
            this.editForm.id = row.id;
            this.editForm.password = "";
            this.editForm.rPassword = "";
            this.mdyPasswordDialogVisible = true;
        },
        onSubmitPwd() {
            let _this = this;
            this.$refs.editForm.validate(valid => {
                if (valid) {
                    this.$axios.post("/admin/user/modify/password", this.editForm)
                        .then(function (response) {
                            let resp = response.data;
                            if (resp.header.status == 0) {
                                _this.$notify({
                                    title: '成功',
                                    message: '数据保存成功',
                                    type: 'success'
                                });
                                _this.mdyPasswordDialogVisible = false;
                                _this.onSearch();
                            } else {
                                _this.$notify.error({
                                    title: '错误',
                                    message: resp.header.msg
                                });
                            }
                        });
                }
            })
        },
        handleClose() {},
        uploadSuccess(response) {
            const {header: {status, msg}} = response;
            this.$refs.upload.clearFiles();
            if(status === 0) {
                this.$notify({
                    title: '成功',
                    message: '数据保存成功',
                    type: 'success'
                });
                this.uploadDialogVisible = false;
                this.onSearch();
            } else {
                this.uploadCheckResult = msg;
            }
        },
        setTableHeight() {
            const tablePosition = this.$refs['tablePosition'];
            const {top} = tablePosition.getBoundingClientRect();
            this.tableConfig.height = window.innerHeight - top - HEIGHT_OFFSET;
        }
    },
    created() {
        window.addEventListener("resize", this.setTableHeight);
        this.onSearch();
    },
    mounted() {
        const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        });
        setTimeout(() => {
            this.setTableHeight();
            loading.close();
        }, 500);
    },
    destroyed () {
        window.removeEventListener("resize", this.setTableHeight);
    }
}
</script>
<style>
</style>
